<template>
  <div>
    <!-- <HeaderNavbar /> -->

    <el-row>
      <HeaderNavbar :activeIndex="'5'" />
    </el-row>
    <el-alert
      title="数据质量部分主要考虑数据缺失率，结果采用各城市国控站平均缺失率，其中单季度缺失超过50%的站点被视为停运不纳入计算"
      type="error"
    >
    </el-alert>
    <el-row>
      <DataCity />
    </el-row>

    <el-row>
      <DataCityMainPull />
    </el-row>

    <el-row>
      <DataArea />
    </el-row>
    <!-- 
    <el-row>
      <h1>各城市污染物数据缺失率</h1>
      <h4>0表示无缺失，1表示全部缺失</h4>
      <el-table
        height="420"
        :data="
          tableData.filter(
            (data) =>
              !search || data.name.toLowerCase().includes(search.toLowerCase())
          )
        "
      >
        <el-table-column
          :filters="cityfilters"
          :filter-method="filterHandler"
          label="City"
          prop="city"
          sortable
        >
        </el-table-column>
        <el-table-column
          :filters="yearfilters"
          :filter-method="filterHandler"
          label="Year"
          prop="year"
          sortable
        >
        </el-table-column>
        <el-table-column
          :filters="seasonfilters"
          :filter-method="filterHandler"
          label="Season"
          prop="season"
          sortable
        >
        </el-table-column>
        <el-table-column label="PM2.5" prop="pm2_5" sortable> </el-table-column>
        <el-table-column label="PM10" prop="pm10" sortable> </el-table-column>
        <el-table-column label="NO2" prop="no2" sortable> </el-table-column>
        <el-table-column label="CO" prop="co" sortable> </el-table-column>
        <el-table-column label="SO2" prop="so2" sortable> </el-table-column>
        <el-table-column label="O3" prop="o3" sortable> </el-table-column>
      </el-table>
    </el-row> -->
    <el-row>
      <HFooter />
    </el-row>
  </div>
</template>
<style scoped>
.el-header {
  padding: 0;
}
.el-main {
  padding: 0;
}
</style>
<script>
import HeaderNavbar from "@/components/HeaderNavbar.vue";
import HFooter from "@/components/HFooter.vue";

import Top10 from "@/components/Data/Top10.vue";
import DataCity from "@/components/Data/DataCity.vue";
import DataCityMainPull from "@/components/Data/DataCityMainPull.vue";
import DataArea from "@/components/Data/DataArea.vue";

export default {
  // name: "Home",
  data() {
    return {
      eleheight: 420,
      tableData: [],
      cityfilters: [],
      yearfilters: [],
      seasonfilters: [],
      search: "",
    };
  },
  components: {
    HeaderNavbar,
    HFooter,
    Top10,
    DataCity,
    DataCityMainPull,
    DataArea,
  },
  methods: {
    filterHandler(value, row, column) {
      // console.log(value, row, column);
      const property = column["property"];
      return row[property] === value;
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },

    getMissRate() {
      this.$axios
        // .post("/AQAssess/getData.php", {
        //   database: "miss_rate",
        // })

        .get("/AQAssess/getMissRateData")
        .then((res) => {
          res.data.forEach((element) => {
            // this.tableData = [];
            this.cityfilters.push(element[0]);
            this.yearfilters.push(element[1]);
            this.seasonfilters.push(element[2]);

            this.tableData.push({
              city: element[0],
              year: element[1],
              season: element[2],
              pm2_5: parseFloat(element[3]),
              pm10: parseFloat(element[4]),
              so2: parseFloat(element[5]),
              no2: parseFloat(element[6]),
              co: parseFloat(element[7]),
              o3: parseFloat(element[8]),
            });
          });

          // 去重并转换
          let temp = [];
          Array.from(new Set(this.cityfilters)).forEach((element) => {
            temp.push({ text: element, value: element });
          });

          this.cityfilters = temp;

          temp = [];
          Array.from(new Set(this.yearfilters)).forEach((element) => {
            temp.push({ text: element, value: element });
          });

          this.yearfilters = temp;

          temp = [];
          Array.from(new Set(this.seasonfilters)).forEach((element) => {
            temp.push({ text: element, value: element });
          });

          this.seasonfilters = temp;
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: "获取" + this.cityname + "缺失率数据失败",
          });
        });
    },
  },
  created() {},
  mounted() {
    // this.getMissRate();
    // this.$message({
    //   type: "success",
    //   message: "获取数据数据中",
    // });
    // this.eleheight = document.documentElement.clientHeight - 248;
  },
};
</script>
